import { ResourceLink } from "@/components/ResourceLink.tsx";
import { eBillingAccountQueryAtom } from "@/modules/billing/billingAccountQuery.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { Trans } from "@lingui/react/macro";
import type { BillingAccountId } from "@warrenio/api-spec/spec.oats.gen";

export function BillingAccountLink({ billingAccountId }: { billingAccountId: BillingAccountId }) {
    const data = useSuspenseQueryAtom(eBillingAccountQueryAtom);
    const account = data.get(billingAccountId);

    return account ? (
        <ResourceLink item={account.account} title={account.title} />
    ) : (
        <span className="text-error">
            <Trans>Unknown</Trans>
        </span>
    );
}
